import { render } from "./ManagePackages.vue?vue&type=template&id=78a611e1&scoped=true"
import script from "./ManagePackages.vue?vue&type=script&lang=js"
export * from "./ManagePackages.vue?vue&type=script&lang=js"

import "./ManagePackages.vue?vue&type=style&index=0&id=78a611e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78a611e1"]])

export default __exports__